var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 7 12",
    style: {
      enableBackground: "new 0 0 7 12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -17 -14 )"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.1,20.3C17,20.2,17,20.1,17,20s0-0.2,0.1-0.3l5.6-5.6C22.8,14,22.9,14,23,14s0.2,0,0.3,0.1l0.6,0.6 C24,14.8,24,14.9,24,15c0,0.1,0,0.2-0.1,0.3L19.2,20l4.7,4.7C24,24.8,24,24.9,24,25c0,0.1,0,0.2-0.1,0.3l-0.6,0.6 C23.2,26,23.1,26,23,26s-0.2,0-0.3-0.1L17.1,20.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.f94f6a396132139965dc218df10c9a80.svg";
export { ForwardRef as ReactComponent };